<template>
	<div class="analytics-container mb-6">
		<!-- For each analytics definition returned from server -->
		<div class="w-100 flex-center flex-column" v-if="!analyticsCharts.length && !analyticsLoading">
			<span class="w-100 white--text small-text text-left white-p">No analytics config.</span>
		</div>
		<div class="w-100 flex-center flex-column mt-4" v-if="analyticsLoading">
			<v-progress-linear indeterminate color="primary" />
			<span class="w-100 white--text small-text text-center mt-5 white-p">Loading analytics...</span>
		</div>
		<template v-else>
			<div v-for="(chart, index) in analyticsCharts" :key="index" class="analytics-chart glass-col pt-3 px-4">
				<div class="w-100 d-flex align-center justify-start mb-2 px-2">
					<h4 class="font-weight-regular">{{ chart.title }}</h4>
					<!-- TIME RANGE SELECTOR -->
					<v-select
						max-width="110"
						:items="chart.timeRangeOptions"
						v-model="chart.selectedRange"
						variant="underlined"
						class="mb-3 ml-4"
						@update:modelValue="fetchChartData(index)"
						density="compact"
						hide-details />
				</div>

				<admin-chart :data="chart.data" :chartType="chart.chartType" :title="chart.title" />
			</div>
		</template>
	</div>
</template>

<script>
	import axios from "axios"
	import AdminChart from "./AdminChart.vue"

	export default {
		name: "AdminAnalytics",
		components: {
			AdminChart,
		},
		props: {
			module: {
				type: Object,
				required: true,
			},
			records: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				analyticsCharts: [],
				analyticsLoading: true,
			}
		},
		mounted() {
			this.fetchAllAnalytics()
		},
		methods: {
			fetchAllAnalytics() {
				axios
					.get(`/admin/${this.module.slug}/analytics`)
					.then((response) => {
						this.analyticsCharts = response.data.map((def) => {
							return {
								...def,
								timeRangeOptions: ["7_days", "30_days", "all_time"],
								selectedRange: def.range,
							}
						})
					})
					.catch((err) => {
						console.error("Error fetching analytics:", err)
					})
					.finally(() => {
						this.analyticsLoading = false
					})
			},

			fetchChartData(index) {
				const chartDef = this.analyticsCharts[index]
				axios
					.get(`/admin/${this.module.slug}/analytics?range=${chartDef.selectedRange}`)
					.then((response) => {
						const updatedAnalytics = response.data
						const match = updatedAnalytics.find((a) => a.field === chartDef.field)
						if (match) {
							// Replace the item at `index` with the merged data
							this.analyticsCharts.splice(index, 1, {
								...chartDef,
								...match,
								selectedRange: chartDef.selectedRange,
							})
						}
					})
					.catch((err) => {
						console.error("Error fetching chart data:", err)
					})
			},
		},
	}
</script>

<style scoped>
	.analytics-container {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
	}
	.analytics-chart {
		padding: 12px;
		flex: 1 1 300px;
		min-width: 300px;
		color: #fff; /* If you need text color for a dark theme */
	}
</style>
